import { handleSubmit } from 'src/viewLayer/components/nodes/InputNode/handleSubmit';
import {
  CaptchaConfigResponse,
  ExecuteCaptchaParams,
  SetCaptchaConfig
} from 'src/viewLayer/components/nodes/InputNode/Captcha/types';
import { CAPTCHA_CONFIG_URL } from 'src/dataLayer/env';
import makeAjaxRequest from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest';
import { DEFAULT_CAPTCHA_CONFIG } from 'src/dataLayer/localData/captcha';

// This function fetches the captcha config from the backend and sets it in the state
export const getCaptchaConfig = async (setCaptchaConfig: SetCaptchaConfig): Promise<void> => {
  try {
    const data = await makeAjaxRequest<CaptchaConfigResponse>({
      verb: 'GET',
      url: CAPTCHA_CONFIG_URL
    }) as CaptchaConfigResponse;

    const captchaConfig = { provider: data.provider, sitekey: data.site_key };

    setCaptchaConfig(captchaConfig);
  } catch {
    setCaptchaConfig(DEFAULT_CAPTCHA_CONFIG);
  }
};

export const handleSubmitWithCaptcha = ({
  event,
  showCaptcha,
  captchaRef,
  submitParams
}: ExecuteCaptchaParams): void | Promise<void> => {
  event.preventDefault();
  return showCaptcha && captchaRef.current ? captchaRef.current.execute() : handleSubmit(submitParams);
};
